import { h } from "preact";

import Color from "../../../foundation/model/color";
import classname from "../../../foundation/utils/classname";
import { getMarkerCSSVariableForApiColor } from "../../../foundation/utils/color";

import { stopPropagation } from "../../../foundation/utils/legacy";
import ColorDot from "../ColorDot";

import styles from "./ColorDotSelector.module.css";

const DEFAULT_COLORS: Color[] = [
    {
        name: "yellow", r: 254, g: 207, b: 51, a: 1
    },
    {
        name: "orange", r: 246, g: 152, b: 51, a: 1
    },
    {
        name: "peach", r: 238, g: 103, b: 35, a: 1
    },
    {
        name: "green", r: 200, g: 207, b: 45, a: 1
    },
    {
        name: "turquoise", r: 13, g: 207, b: 218, a: 1
    },
    {
        name: "cornflowerBlue", r: 65, g: 155, b: 249, a: 1
    },
    {
        name: "deepPurple", r: 219, g: 124, b: 238, a: 1
    }
].map(colorData => new Color(colorData));

interface Props {
    class?: string;
    itemId: string;
    outline: boolean;
    selectedColor: Color;
    colorSelectable: boolean;
    colors?: Color[];
    onColorSelect?: (itemId: string, color: Color) => void;
}

export default function ColorDotSelector({
    class: cssClass,
    itemId,
    outline,
    selectedColor,
    colorSelectable,
    colors = DEFAULT_COLORS,
    onColorSelect
}: Props) {
    function handleColorDotClick(color: Color) {
        if (color === selectedColor) {
            return;
        }

        onColorSelect?.(itemId, color);
    }

    function renderColorDot(color: Color) {
        function onClick() {
            handleColorDotClick(color);
        }

        return (
            <ColorDot
                key={`${color.name}-colorDot`}
                color={getMarkerCSSVariableForApiColor(color) ?? color.toRGBAString()}
                selected={color.name === selectedColor.name}
                onClick={onClick}/>
        );
    }

    return (
        <div class={classname(
            styles.colorSelector,
            cssClass,
            { [styles.selectable]: colorSelectable }
        )}
        onClick={stopPropagation}>
            <ColorDot
                class={styles.colorDotIndicator}
                key={`${selectedColor.name}-viewOnly`}
                color={getMarkerCSSVariableForApiColor(selectedColor) ?? selectedColor.toRGBAString()}
                selected={outline}/>
            {colorSelectable && (
                <div class={styles.colorDotsContainer}>
                    <div class={styles.colorDots}>
                        {colors.map(color => renderColorDot(color))}
                    </div>
                </div>
            )}
        </div>
    );
}

export { DEFAULT_COLORS };
